import Controller from './Controller';
import type Report from '../checks/Report';
import { Combined_CreateTransition } from '../commands/combined';
import { CEMC_Transition } from '../commands/metamodel/complex';
import type { IModelVersion } from './Controller';
import type { OrId } from '../commands/types';
import type { IState } from '../../stores/model/metamodel/state';
import type { ITransition } from '../../stores/model/metamodel/transition';
import type { IMethod } from '../../stores/model/metamodel/method';

/**
 * Controller to add a new transition to an FSM or edit an exiting one.
 */
export default class AddOrEditTransitionController extends Controller {
  objectTypeId: string;
  fsmId: string;

  constructor(modelVersion: IModelVersion, objectTypeId: string, fsmId: string) {
    super(modelVersion);
    this.objectTypeId = objectTypeId;
    this.fsmId = fsmId;
  }

  /**
   * Add a new transition.
   *
   * @param {String} source The source state.
   * @param {String} target The target state.
   * @param {String[]} methods The methods for the transition.
   */
  addTransition = async (
    source: OrId<IState>,
    target: OrId<IState>,
    methods: OrId<IMethod>[]
  ): Promise<Report> => {
    return this.executeAndCheck((model) => {
      const { checks } = Combined_CreateTransition(
        model,
        this.objectTypeId,
        this.fsmId,
        source,
        target,
        methods
      );
      return checks;
    });
  };

  /**
   * Edit a transition.
   *
   * @param {String} transition The transition.
   * @param {String[]} methods The methods for the transition.
   */
  editTransition = async (
    transition: OrId<ITransition>,
    methods: OrId<IMethod>[]
  ): Promise<Report> => {
    return this.executeAndCheck((model) => {
      const { checks } = CEMC_Transition(model, this.objectTypeId, this.fsmId, transition, methods);
      return checks;
    });
  };
}
